import React from "react";

const TermsConditions = () => {
    return (
        <div className="container mx-auto px-12 relative pt-162 min-h-calc-head py-8">
            <div className="wrapper mt-20">
                <h1 className="text-white text-3xl font-bold mb-4">Terms and Conditions of Metafluence</h1>
                <p className="font-light mb-0 mb-12 text-base">
                    Welcome to Metafluence, a virtual world built on the Ethereum blockchain. By accessing or using
                    Metafluence, you agree to the following terms and conditions:
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Acceptance of Terms and Conditions</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    By accessing or using Metafluence, you agree to be bound by these terms and conditions, as well as our
                    Privacy Policy. If you do not agree to these terms, you should not use Metafluence.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Use of Metafluence</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    Metafluence is intended for use by individuals who are at least 18 years of age. If you are under 18, you
                    may only use Metafluence with the permission of a parent or guardian.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Ownership of LAND AND/OR METAHUT and METO</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    Metafluence is built on the blockchain, and ownership of virtual LAND and/or METAHUT, METO tokens or
                    other assets or func-onali-es is recorded on the blockchain. We are not responsible for any loss of LAND
                    and/or METAHUT, METO tokens or other assets or func-onali-es due to theP or other causes.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Prohibited Ac-vi-es</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    You agree not to use Metafluence for any illegal or unauthorized purpose, including but not limited to:
                </p>
                <p className="font-light mb-0 mb-12 text-base">
                    a. Viola-ng any applicable laws or regula-ons;<br/>
                    b. AUemp-ng to gain unauthorized access to Metafluence or other users' accounts;<br/>
                    c. Interfering with Metafluence's opera-on, including but not limited to introducing viruses or other
                    harmful code;<br/>
                    d. Engaging in any ac-vity that is harmful to other users or to Metafluence.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">User Content</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    You are solely responsible for any content that you upload, publish, or transmit through Metafluence,
                    including but not limited to text, images, videos, and other materials. You represent and warrant that
                    you have the necessary rights to publish such content, and that such content is not defamatory,
                    infringing, or otherwise unlawful.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Disclaimers and Limita-on of Liability</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    Metafluence is provided "as is" without any warran-es, express or implied. We are not responsible for
                    any losses or damages arising from your use of Metafluence, including but not limited to any loss of
                    LAND and/or METAHUT, METO tokens or other assets or func-onali-es.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Indemnifica-on</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    You agree to indemnify and hold us harmless from any claims, damages, or expenses arising from your
                    use of Metafluence, including but not limited to any viola-on of these terms and conditions.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Changes to Terms and Conditions</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    We reserve the right to modify these terms and conditions at any -me. Any changes will be posted on
                    our website, and your con-nued use of Metafluence aPer such changes have been posted will cons-tute
                    your acceptance of the revised terms and conditions.
                </p>

                <h3 className="text-gray-300 text-xl font-normal mb-4">Governing Law and Dispute Resolu-on</h3>
                <p className="font-light mb-0 mb-12 text-base">
                    These terms and conditions will be governed by and construed in accordance with the laws of United
                    Arab Emirates. Any dispute arising out of or rela-ng to these terms and conditions or your use of
                    Metafluence will be resolved through binding arbitra-on in accordance with the rules of the UAE
                    Arbitra-on.
                </p>
            </div>
        </div>
    )
}

export default TermsConditions;